import { z } from "zod";

// User Role Schema
export const UserRoleSchema = z.enum(["admin", "member"]);
export type UserRole = z.infer<typeof UserRoleSchema>;

// Member Role Schema
export const MemberRoleSchema = z.enum(["Primary Owner", "Owner", "Manager"]);
export type MemberRole = z.infer<typeof MemberRoleSchema>;

// Member Status Schema
export const MemberStatusSchema = z.enum([
  "active",
  "invited",
  "removed",
  "pending_verification",
  "archived",
]);
export type MemberStatus = z.infer<typeof MemberStatusSchema>;

// Business Status Schema - Updated to remove 'deactivated'
export const BusinessStatusSchema = z.enum(["onboarding", "active", "paused"]);
export type BusinessStatus = z.infer<typeof BusinessStatusSchema>;

// Entity Type enum
export const EntityTypeSchema = z.enum(["portfolio", "business"]);
export type EntityType = z.infer<typeof EntityTypeSchema>;
